import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DuplicateTvBrandDocument } from './duplicate.generated';

export const useDuplicateTVBrand = (options: ApiOptions<typeof DuplicateTvBrandDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DuplicateTvBrandDocument, {
    ...useNotifications(DuplicateTvBrandDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.tv_brands.duplicate_success'),
    }),

    ...options,
  });
};
